import { isString } from 'lodash';
import { useContext } from 'react';
import { Constants } from '../constants/constants';
import { AdminContext } from '../context/admin-context';
import { TenantContext } from '../context/tenant-context';

export type AdminContextType = {
  id: number;
  name: string;
  username: string;
  email: string;
  hasPermissions: (permission: string | string[]) => boolean;
  isSuperAdmin: boolean;
  contextPath: string;
  tenant: string;
  configuration?: {
    currency: string;
    showDispatchTransition: boolean;
    // @hipaa-exclude
    qboEnabled: boolean;
  };
  initials: string;
};

export const useAdmin = (): AdminContextType => {
  const { id, name, email, username, permissions } = useContext(AdminContext);
  const { contextPath, tenant, configuration } = useContext(TenantContext);

  const isSuperAdmin: boolean = permissions.includes(Constants.Permissions.Super_Admin);
  const getAdminInitials = () => {
    const names = name.toLocaleUpperCase().split(' ');

    return names.length > 1 ? `${names[0][0]}${names[1][0]}` : `${names[0].substring(0, 2)}`;
  };

  return {
    id,
    name,
    email,
    username,
    hasPermissions: (permission: string | string[]): boolean => {
      if (isSuperAdmin) {
        return true;
      } else if (Array.isArray(permission)) {
        return permission.every((perm) => permissions.includes(perm));
      } else if (isString(permission)) {
        return permissions.includes(permission);
      } else {
        return false;
      }
    },
    isSuperAdmin,
    contextPath,
    tenant,
    configuration,
    initials: getAdminInitials(),
  };
};
